import { SectionLabel } from "./Disciplines";
import { Box, Hammer, Lightbulb, Recycle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const labs = [
  {
    icon: Box,
    code: "LAB-01",
    title: "Fabricación 3D",
    desc: "De la idea al objeto físico. Modelado paramétrico, slicing, materiales (PLA, PETG, resina, metal). Diseño para impresión y postprocesado.",
    skills: ["Fusion 360", "Cura", "Bambu Lab", "Resina SLA"],
    to: "/herramientas/cad_bridge",
  },
  {
    icon: Hammer,
    code: "LAB-02",
    title: "Sin máquina · Manos al fuego",
    desc: "Construcción con materiales accesibles: madera, metal reciclado, hormigón, barro, bambú. Herramientas de mano y oficio puro.",
    skills: ["Carpintería", "Soldadura", "Albañilería", "Fundición"],
    to: "/herramientas/inventory",
  },
  {
    icon: Lightbulb,
    code: "LAB-03",
    title: "Reinvención",
    desc: "Tomamos un invento histórico —el motor de Tesla, la prensa de Gutenberg, la bomba de Arquímedes— y lo reconstruimos con materiales modernos.",
    skills: ["Ingeniería inversa", "Prototipado", "Documentación"],
    to: "/herramientas/council",
  },
  {
    icon: Recycle,
    code: "LAB-04",
    title: "Energías renovables",
    desc: "Paneles solares DIY, micro-eólica, baterías caseras, sistemas hidráulicos. Autonomía energética desde cero en Puerto Rico.",
    skills: ["Solar PV", "MPPT", "LiFePO4", "Almacenamiento"],
    to: "/herramientas/solar",
  },
];

export const Labs = () => (
  <section id="laboratorios" className="relative py-32 border-t border-border overflow-hidden">
    <div className="absolute inset-0 grid-blueprint opacity-20" />
    <div className="container relative">
      <SectionLabel index="04" title="Laboratorios" />
      <h2 className="font-serif-display text-4xl md:text-6xl font-light max-w-3xl mb-20 leading-tight">
        Cuatro talleres. <span className="text-ember italic">Infinitas creaciones.</span>
      </h2>

      <div className="grid md:grid-cols-2 gap-6">
        {labs.map((lab) => (
          <div
            key={lab.code}
            className="group relative border border-border bg-card/40 backdrop-blur-sm p-8 md:p-10 hover:border-primary/60 transition-all duration-500 hover:-translate-y-1 flex flex-col justify-between"
          >
            <div>
              <div className="flex items-start justify-between mb-8">
                <div className="w-12 h-12 border border-primary/40 flex items-center justify-center group-hover:bg-primary/10 group-hover:border-primary transition-all duration-500">
                  <lab.icon className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <span className="font-mono-tech text-[10px] text-muted-foreground tracking-widest">
                  {lab.code}
                </span>
              </div>

              <h3 className="font-serif-display text-2xl md:text-3xl mb-4">{lab.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-6">{lab.desc}</p>

              <div className="flex flex-wrap gap-2 pt-6 border-t border-border/60">
                {lab.skills.map((s) => (
                  <span
                    key={s}
                    className="font-mono-tech text-[10px] uppercase tracking-wider px-2 py-1 border border-border text-muted-foreground"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>

            <div className="pt-6 mt-6 border-t border-border/40">
              <Link
                to={lab.to}
                className="inline-flex items-center justify-between w-full text-xs font-mono-tech uppercase tracking-wider text-primary group-hover:text-primary-glow font-bold transition-all"
              >
                <span>Abrir en Suite de Ingeniería</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);